import { useEffect, useState } from "react";
import { Carousel } from "react-bootstrap";
import { FiSearch } from "react-icons/fi";
import { MdOutlineHomeWork } from "react-icons/md";
import { RiVerifiedBadgeFill } from "react-icons/ri";
import { Link } from "react-router-dom";
import axiosInstance from "../axios";
import "../styles/hero-section.css";

const HeroSection = () => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;

    const fetchBanners = async () => {
      try {
        const response = await axiosInstance.get("/banners");

        if (!mounted) return;

        if (response?.data?.success) {
          setBanners(Array.isArray(response.data.data) ? response.data.data : []);
        } else {
          setError("Gagal memuat konten banner.");
        }
      } catch (err) {
        if (mounted) {
          setError("Gagal terhubung ke server.");
        }
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    };

    fetchBanners();

    return () => {
      mounted = false;
    };
  }, []);

  if (loading) {
    return (
      <section className="home-hero home-hero--loading" aria-busy="true" aria-live="polite">
        <div className="home-hero__spinner" />
        <p className="home-hero__loading-text">Memuat konten...</p>
      </section>
    );
  }

  if (error) {
    return (
      <section className="home-hero home-hero--loading" aria-live="assertive">
        <p className="home-hero__error-text">{error}</p>
      </section>
    );
  }

  if (!banners.length) {
    return (
      <section className="home-hero home-hero--loading" aria-live="polite">
        <p className="home-hero__error-text">Belum ada banner yang tersedia.</p>
      </section>
    );
  }

  return (
    <section className="home-hero">
      <Carousel
        fade
        interval={5500}
        indicators
        controls={false}
        pause="hover"
        touch
        className="home-hero__carousel"
      >
        {banners.map((banner) => (
          <Carousel.Item key={banner.id}>
            <div className="home-hero__media">
              <img
                className="home-hero__image"
                src={banner.image_url}
                alt={banner.title || "Banner properti"}
                loading="eager"
                onError={(e) => {
                  e.currentTarget.src = "/fallback.jpg";
                }}
              />
              <div className="home-hero__overlay" />
            </div>

            <div className="home-hero__content">
              <div className="home-hero__badge">
                <RiVerifiedBadgeFill size={14} />
                Platform Properti Terpercaya
              </div>

              <h1 className="home-hero__title">{banner.title}</h1>

              <p className="home-hero__subtitle">
                Temukan hunian impian atau properti investasi terbaik — dengan
                pengalaman yang lebih nyaman, cepat, dan terpercaya.
              </p>

              <div className="home-hero__actions">
                <Link
                  to="/all-properties"
                  className="home-hero__btn home-hero__btn--primary"
                >
                  <FiSearch size={17} />
                  Cari Properti
                </Link>

                <Link
                  to="/sell-property"
                  className="home-hero__btn home-hero__btn--secondary"
                >
                  <MdOutlineHomeWork size={18} />
                  Jual / Sewakan Properti Anda
                </Link>
              </div>
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    </section>
  );
};

export default HeroSection;
